import { combineReducers } from 'redux';
import acareacoes from './slices/acareacoes.slice';

const reducer = combineReducers({
  acareacoes
})

export default reducer;
